// option_selection.js sets Shopify.money_format to "${{amount}}", which
// Shopify.formatMoney falls back to. Replace it with the shopper's currency
// format (see snippets/money-format.liquid) before product.js runs.
(function () {
  var theme = window.theme;
  if (window.Shopify && theme && theme.shop && theme.shop.money_format) {
    window.Shopify.money_format = theme.shop.money_format;
  }
})();
